import React, {Fragment} from 'react';
import clsx from 'clsx';
import {Link} from 'react-router-dom';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import {IconButton, Box} from '@material-ui/core';
import logoSmall from '../../../assets/images/logos/logo_header_small.svg';
import {setActiveLink} from "../../../vendors/actions/layout";

interface OwnProps {
    getUserInfo?: any

}

interface ConnectStateProps {}

interface ConnectDispatchProps {
    setActiveLink: (data: string) => void,
}


const HeaderLogo = (props: any) => {
    const {sidebarToggle, sidebarHover} = props.Layout;
    return (
        <Fragment>
            <div
                className={clsx('app-header-logo', {
                    'app-header-logo-close': sidebarToggle,
                    'app-header-logo-open': sidebarHover
                })}>
                <Box
                    className="header-logo-wrapper"
                    title="Carolina React Admin Dashboard with Material-UI PRO">
                    <Link to="/dashboard"
                          onClick={() => props.setActiveLink('/dashboard')}
                          className="header-logo-wrapper-link">
                        <IconButton
                            color="primary"
                            size="medium"
                            className="header-logo-wrapper-btn">
                            <img
                              className="app-header-logo-img"
                              alt="Carolina React Admin Dashboard with Material-UI PRO"
                              src={logoSmall}
                            />
                        </IconButton>
                    </Link>
                    <Link to="/dashboard"
                          onClick={() => props.setActiveLink('/dashboard')}
                          className="header-logo-text">And<span color="#000066">Lawyers</span>
                    </Link>
                </Box>
            </div>
        </Fragment>
    );
};

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {Layout} = state;
    return {
        Layout
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        setActiveLink: (data: string) => dispatch(setActiveLink(data)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderLogo);


